import BaseView from '../base-view';
import Socket from '../utils/socket';
import LanguagePickerView from '../components/language-picker/view';
import NavigationView from '../components/navigation/view';
import FormValidationView from '../components/form-validation/view';
import AlertsView from '../components/alerts/view';
import TabListView from '../components/tab-list/view';

export default BaseView.extend({
	initialize: function() {
		// create socket
		if (window.signalRConfig) {
			this.socket = new Socket(window.signalRConfig);
		}

		// create subviews
		var alerts = this.query('.js-alerts'),
			navigation = this.query('.js-navigation'),
			tabLists = this.queryAll('.js-tab-list');

		if (navigation) {
			this.navigationView = new NavigationView({
				el: '.js-navigation'
			});
		}

		// create toggable sidebar if sidebar exists
		if (alerts) {
			this.alertsView = new AlertsView({
				el: alerts
			});
		}

		if (tabLists) {
			this.tabListViews = tabLists.map(function(tabList) {
				return new TabListView({
					el: tabList
				});
			});
		}

		// create language selector
		this.languagePickerView = new LanguagePickerView({
			el: '.js-language-picker'
		});

		// create parsley forms
		this.parsleyForms = this.createParsleyForms();
	},

	/**
	 * Create Parsley forms for validation
	 **/
	createParsleyForms: function() {
		// get forms to validate
		var $validateForms = this.$el.find('.js-form-validate');

		if ($validateForms.length) {
			// create and return array of parsley forms
			return $validateForms.map(function(index, formEl) {
				return new FormValidationView({el: formEl});
			});
		} else {
			// return null when there're no forms
			return null;
		}
	}
});
